var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BranchInfoData } from "../BranchInfoData";
var BranchInfo = /** @class */ (function (_super) {
    __extends(BranchInfo, _super);
    function BranchInfo(branchInfo) {
        return _super.call(this, branchInfo) || this;
    }
    BranchInfo.prototype.equals = function (branchInfo) {
        return this.ID === branchInfo.ID &&
            this.Name === branchInfo.Name &&
            this.RankID === branchInfo.RankID &&
            this.TotalLiveCount === branchInfo.TotalLiveCount;
    };
    return BranchInfo;
}(BranchInfoData));
export { BranchInfo };
//# sourceMappingURL=BranchInfo.js.map